<section>
    <hr *ngIf="isMobile">
    <div class="column is-6 resumo-compra" *ngIf="result && propostaResult">
        <div class="area-fixed-resumo">
            <div class="seu-plano">
                <div id="cupom">
                    <p class="add-cupom"><strong><i class="fas fa-ticket-alt"></i>Cupom</strong></p>
                    <input type="text"
                           [(ngModel)]="cupom"
                           class="sucess"
                           placeholder="Insira um cupom"
                           name="cupom"
                           (input)="onLimpaCupom()">
                    <label class="text-sucess"
                           *ngIf="isCupomValido == null && cupom"
                           style="cursor: pointer;"
                           (click)="onValidaCupom()">
                        Aplicar cupom
                    </label>
                    <label class="text-sucess"
                           *ngIf="isCupomValido != null && isCupomValido && cupom">
                        Cupom aplicado
                    </label>
                    <label class="text-error"
                           *ngIf="isCupomValido != null && !isCupomValido && cupom">
                        {{couponMessage}}
                    </label>
                    <p *ngIf="mensagemCupom" class="prazo-cupom"><small>{{mensagemCupom}}</small></p>
                    <p *ngIf="!mensagemCupom">&nbsp;</p>
                </div>

                <div id="detalhes">
                    <h3>Detalhes da Sua Assinatura(s)</h3>
                    <p class="colunas"><span>Diárias</span>
                        <span class="coluna-right">{{totalDiarias}} diárias</span>
                    </p>
                    <p class="colunas">
                        <span>Quartos Duplos</span>
                        <span class="coluna-right">{{result ? result.quartoDuplo : '0'}} quarto(s)</span>
                    </p>
                    <p class="colunas">
                        <span>Quartos Triplos</span>
                        <span class="coluna-right">{{result ? result.quartoTriplo : '0'}} quarto(s)</span>
                    </p>
<!--                    <p class="colunas">-->
<!--                        <span>Taxa de Adesão</span>-->
<!--                        <span class="coluna-meio__desconto">-->
<!--                            De: {{result ? result.valorAdesao.toString() : '0' }}-->
<!--                        </span>-->
<!--                        <span class="coluna-right">Por: {{result ? result.valorAdesaoDesconto.toString() : 'R$ 0,00' }}</span>-->
<!--                    </p>-->
                </div>

                <div id="valor-final">
                    <h3>Valor Final da(s) Assinatura(s)</h3>
                    <p class="valor-plano" *ngIf="!isCupomValido">
                        <span class="valor">
                            {{ valorMensalidade(result).mensalidade}}
                        /
                        <span>mês</span></span>
                    </p>
                    <p class="valor-plano" *ngIf="isCupomValido">
                        <span class="valor valor-mensalidade-desconto">
                            De: {{ valorMensalidade(result).mensalidade}}
                        </span>
                        <span class="valor">
                            Por: {{ valorMensalidade(result).mensalidadeDesconto}}
                            /
                        <span>mês</span></span>
                    </p>
                </div>
            </div>
            <div>
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</section>
